<template>
  <NavBar />
  <div class="container-fluid page-body-wrapper">
    <MenuBar />
    <div class="main-panel">
      <div class="content-wrapper">
        <div class="page-header">
          <h3 class="page-title">
            <span class="page-title-icon bg-gradient-primary text-white me-2">
              <i class="mdi mdi-account"></i>
            </span>
            User Management
          </h3>
          <a
            class="btn btn-block btn-lg btn-gradient-primary mt-4"
            @click="btnAddNewClicked"
            >+ Add New User</a
          >
        </div>
        <ManageUser
          v-if="blnShowManageUserSec"
          v-on:posted-data="getPostedData"
          v-on:is_cance_clicked="getEventStatus"
          :objUser="objSelectedUser"
          :action_mode="selected_action_mode"
        >
        </ManageUser>
        <div class="row" v-if="uniqueEmailValMsg != null">
          <p
            style="
              width: 100%;
              margin-top: 0.25rem;
              font-size: 0.8em;
              color: #dc3545;
            "
          >
            {{ uniqueEmailValMsg }}
          </p>
        </div>
        <div class="row">
          <div class="col-12 grid-margin">
            <div class="card">
              <div class="card-body">
                <!-- :userListObject="lstUserDetail" -->
                <UserList
                  v-on:selected-data="getSelectedData"
                  :toBeRefreshed="toBeRefreshed"
                >
                </UserList>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- <script>
import ManageUser from "@/components/shared/user-management/manage-user.vue";
import MenuBar from "@/components/shared/common/menu-bar.vue";
import NavBar from "@/components/shared/common/nav-bar.vue";
import UserList from "@/components/shared/user-management/user-list.vue";
import { ref } from "vue";

const blnShowManageUserSec = false;
const lstUserDetail = [];
const objSelectedUser = {};
const selected_action_mode = null;
const uniqueEmailValMsg = null;

export default {
  name: "UserManagement",
  components: {
    NavBar,
    MenuBar,
    ManageUser,
    UserList,
  },
  data() {
    return {
      blnShowManageUserSec,
      lstUserDetail,
      objSelectedUser,
      selected_action_mode,
      uniqueEmailValMsg,
    };
  },
  methods: {},
};
</script> -->

<script setup>
import ManageUser from "@/components/shared/user-management/manage-user.vue";
import MenuBar from "@/components/shared/common/menu-bar.vue";
import NavBar from "@/components/shared/common/nav-bar.vue";
import { ref, onMounted } from "vue";
import UserList from "@/components/shared/user-management/user-list.vue";
import { useAuthStore } from "@/store/auth_store";

const auth_store = useAuthStore();
const blnShowManageUserSec = ref(false);
const lstUserDetail = ref([]);
const objSelectedUser = ref({});
const selected_action_mode = ref(null);
const uniqueEmailValMsg = ref(null);
const user = ref(null);
const toBeRefreshed = ref(false);

onMounted(() => {
  user.value = auth_store.logged_in_user.user;
});

const btnAddNewClicked = () => {
  toBeRefreshed.value = false;
  objSelectedUser.value = {
    usr_id: null,
    usr_user_name: "",
    usr_email: "",
    usr_password: "",
    urm_id: -1,
    usr_created_on: new Date(),
    usr_created_by: 106, //user.usr_id,
    usr_modified_on: null,
    usr_modified_by: null, //loggedin user id
    usr_status: 1,
    usr_confirm_pass: "",
  };
  selected_action_mode.value = "Add";
  blnShowManageUserSec.value = true;
};

const getPostedData = (obj) => {
  uniqueEmailValMsg.value = null;
  lstUserDetail.value.push(obj);
  blnShowManageUserSec.value = false;
  toBeRefreshed.value = true;
};

const getEventStatus = (is_canceled) => {
  if (is_canceled == true) {
    blnShowManageUserSec.value = false;
    toBeRefreshed.value = true;
  }
};

const getSelectedData = (objselectedItem) => {
  if (objselectedItem != null) {
    objSelectedUser.value = objselectedItem;
    selected_action_mode.value = "update";
    blnShowManageUserSec.value = true;
  }
};
</script>
